const moment = require("moment");

export const acmApiPaginatedResponseMapper = (response) => {
  var isSuccess = response.isSucceeded;
  var code = response.status.code;
  var message = response.status.message;
  var isPartial = code === 3;
  var successObj = {};
  var failedObj = {};
  var pageNo = response.data.pageNo;
  var pageSize = response.data.pageSize;
  var totalCount = response.data.count;
  var respData = response.data.data ? response.data.data : [];

  return {
    isSuccess,
    isPartial,
    message,
    respData,
    pageNo,
    pageSize,
    totalCount,
    successObj,
    failedObj,
  };
};

export const addressingApiResponseMapper = (response) => {
  var isSuccess = response.isSucceeded;
  var code = response.status.code;
  var message = response.status.message;
  var isPartial = code === 3;
  var successObj = {};
  var failedObj = {};
  var respData = response.data;

  return {
    isSuccess,
    isPartial,
    message,
    respData,
    successObj,
    failedObj,
  };
};

export const addressIssueStatusTypesMapper = (data) => {
  return data.map((item) => ({
    id: item.id,
    name: item.name,
  }));
};

export const addressIssueTypesMapper = (data, language) => {
  return data.map((item) => ({
    id: item.id,
    name: language == "en" ? item.nameEN : item.nameAR,
  }));
};

export const addressIssuesMapper = (data) => {
  return data.map((item) => ({
    reportUserName: item.reportUserName,
    // reportedDate : item.reportedDate,
    reportedDate: moment(item.reportedDate).format("DD MMM YY"),
    reporterDescription: item.reporterDescription,
    email: item.email,
    mobile: item.mobile,
    longitude: item.longitude,
    latitude: item.latitude,
    searchText: item.searchText,
    fK_Issue_TypeId: item.fK_Issue_TypeId,
    fK_Issue_StatusId: item.fK_Issue_StatusId,
    responderUserName: item.responderUserName,
    responderComments: item.responderComments,
    respondedDate: item.respondedDate,
    id: item.id,
  }));
};

export const addressDetailsMapper = (item) => {
  return {
    addressPointId : item.addressPointId,
    addressId: item.addressID,
    buildingNameE: item.buidlingNameE,
    buildingNameA: item.buildingNameA,
    communityNameE: item.communityNameE,
    communityNameA: item.communityNameA,
    emirate: item.emirate,
    postalCode: item.postalCode,
    countryName: item.countryName,
    longitude: item.longitude,
    positionX: item.positionX,
    positionY: item.positionY,
    makani: item.makani,
    latitude: item.latitude,
    threeWordsEn: item.threeWordsEn,
    threeWordsAr: item.threeWordsAr,
    threeWordsUrdu: item.threeWordsUrdu,
    plusCode: item.plusCode,
    parcelId: item.parcelId,
    fullStreetNameEnglish: item.fullStreetNameEnglish,
    streetNameEnglish: item.streetNameEnglish,
    fullStreetNameArabic: item.fullStreetNameArabic,
    streetNameArabic: item.streetNameArabic,
    areaNameEn: item.areaNameEn,
    areaNameAr: item.areaNameAr,
    parcelGeometry: item.parcelGeometry,
  };
};

export const addressIssueAttachmentMapper = (data) => {
  var item = data[0];
  return {
    fk_Issue_TypeId: item.fk_Issue_TypeId,
    fileName: item.fileName,
    fileContent: item.fileName,
    fileExtension: item.fileExtension,
    id: item.id,
  };
};
